import React from 'react';
import './ExplanationProduct.css';
function ExplanationProduct() {
    return (
        <div className="explanation-product">
            <p className="explanation-product-text">選購方式：</p>
            <p className="explanation-product-text" style={{ textIndent: '2em' }}>1. 查詢與瀏覽您想要的品項（若找不到可以從官方帳號詢問我們喔）</p>
            <p className="explanation-product-text" style={{ textIndent: '2em' }}>2. 點選商品圖片，按下加入願望清單</p>
            <p className="explanation-product-text" style={{ textIndent: '2em' }}>3. 在右上角的愛心符號中查看願望清單</p>
            <p className="explanation-product-text" style={{ textIndent: '2em' }}>4. 將願望清單生成文字檔，傳給官方帳號或者填寫 Google 表單傳送給我們。</p>
            <p className="explanation-product-text" style={{ textIndent: '2em' }}>5. 請靜候片刻，當天或隔天將有客服回覆貨況喔！</p>
        </div>
    );
}

export default ExplanationProduct;
